import {
  isFolderMenuItemType,
  isPageMenuItemType,
  isProcessMenuItemType,
  MenuItem,
} from '@nx-frontend/shared/types/menu';

interface GetIconByMenuItem {
  menuItem: MenuItem;
  parentMenuItem?: MenuItem;
  allowProjectionIcons?: boolean;
}

export const getIconByMenuItem = ({ menuItem, parentMenuItem, allowProjectionIcons }: GetIconByMenuItem): string => {
  const process = isProcessMenuItemType(parentMenuItem) ? parentMenuItem.process : undefined;
  if (process != null) {
    const status = process.items.find((step) => step.id === menuItem.id)?.status;
    return status === 'done' ? 'process_step_done' : 'process_step';
  }

  if (allowProjectionIcons) {
    const isProjection = menuItem.isOrigin === false || menuItem.isOrigin === true;

    if (isPageMenuItemType(menuItem) && isProjection) {
      return 'linked_document';
    }

    if (isFolderMenuItemType(menuItem) && isProjection) {
      return 'linked_folder';
    }
  }

  return menuItem.icon;
};
